const SET_APPLICATIONS = 'SET_APPLICATIONS';

export const APPLICATIONS_ACTION_TYPES = {
    SET_APPLICATIONS
};